const getDashboardDemoStateParam = () =>
  typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('state') : null;

export const isCleanDashboardDemoState = () => getDashboardDemoStateParam() === 'clean';

export const isEmptyDashboardDemoState = () => getDashboardDemoStateParam() === 'empty';

export const pickDashboardDemoData = <T>(emptyData: T, cleanData: T, defaultData: T): T => {
  if (isEmptyDashboardDemoState()) return emptyData;
  if (isCleanDashboardDemoState()) return cleanData;
  return defaultData;
};
